import './filter.less';

import React, {useEffect, useState} from 'react';
import {AutoComplete, Button, DatePicker, Input, Modal, Select} from 'antd';
import {get, uniq} from 'lodash';
import {passDurationText, passStatusText} from './helpers';

const Option = Select.Option;
const InputGroup = Input.Group;

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;


export function Filter({ value, onChange, col, rows }) {
  const type = col.filterType || 'string';
  const defaultValue = { type, val: null };
  const [opened, setOpened] = useState(false);
  const [current, setCurrent] = useState(value || defaultValue);

  useEffect(() => {
    setCurrent(value || defaultValue);
  }, [value]);

  const apply = () => {
    console.log('current', current);
    onChange(current);
    setOpened(false);
  };

  const cancel = () => {
    setOpened(false);
  };

  const reset = () => {
    onChange(defaultValue);
    setOpened(false);
  };

  const renderModal = () => {
    const props = { onChange: value => setCurrent(value), value: current, col: col, rows: rows };
    return (
      <Modal
        visible={true}
        onCancel={() => setOpened(false)}
        onOk={() => onChange(current)}
        footer={[
          <Button key="reset-btn" onClick={() => reset()}>Сбросить</Button>,
          <Button key="cancel-btn" onClick={() => cancel()}>Отменить</Button>,
          <Button key="apply-btn" type={'primary'} onClick={() => apply()}>Применить</Button>
        ]}
        className="filter-modal">

        <div style={{ paddingTop: 24 }}>
          {type === 'string' && <FilterString {...props} />}
          {type === 'date' && <FilterDate {...props} />}
          {type === 'bool' && <FilterBool {...props} />}
          {type === 'passStatus' && <FilterPassStatus {...props} />}
        </div>
      </Modal>
    );
  };

  const renderIcon = () => {
    return <Button icon="filter" type={value && value.val ? 'primary' : ''} size={'small'} onClick={() => setOpened(!opened)} />
  };

  return (
    <div className="col-filter">
      {opened ? renderModal() : renderIcon()}
    </div>
  );
}

function FilterPassStatus({ value, onChange, col, rows }) {
  const status = value.val || 'active';

  const onChangeStatus = (status) => {
    const date = status === 'canceled' ? value.date : null;
    onChange({ ...value, val: status, date })
  };

  const onChangeDate = (newVal) => {
    onChange({ ...value, date: newVal });
  };

  return (
    <div className="col-filter-type col-filter-pass-status">
      <div>
        <h3>Тип</h3>
        <InputGroup>
          <Select value={status} onChange={onChangeStatus} style={{ width: '50%'}}>
            <Option value="active">Активный</Option>
            <Option value="expired">Завершен</Option>
            <Option value="canceled">АНУЛЛИРОВАН</Option>
          </Select>
        </InputGroup>

        {
          status === 'canceled' &&
          <React.Fragment>
            <br/>
            <h3>Дата</h3>
            <FilterDate value={value.date} onChange={onChangeDate} />
          </React.Fragment>
        }
      </div>
    </div>
  );
}


function FilterString({ value, onChange, col, rows }) {
  const [dataSource, setDataSource] = useState([]);
  const searchType = value.searchType || 'in';

  useEffect(() => {
    if (typeof value.val === 'string') {
      const found = uniq(
        rows
          .map(r => (col.format(r) || '').toString().replace(/\s+/g, ' '))
          .filter(i => (i && value && value.val) ? i.toLowerCase().indexOf(value.val.toLowerCase()) > -1: !!i)
      );

      setDataSource(found.slice(0, Math.max(10, found.length)));
    }

  }, [value.val]);

  const onChangeType = (nextVal) => {
    onChange({ ...value, searchType: nextVal })
  };

  const onChangeValue = (newVal) => {
    onChange({ type: 'string', searchType, val: newVal });

  };

  const allValues = uniq(rows.map(opt => (col.format(opt) || '').toString().replace(/\s+/g, ' ')));

  return (
    <div className="col-filter-type col-filter-string">
      <div>
        <InputGroup compact>
          <Select value={searchType} onChange={onChangeType} style={{ width: '80%'}}>
            <Option value="in">Выбор (точное совпадение)</Option>
            <Option value="search">Выбор (вхождение подстроки)</Option>
            <Option value="notIn">Исключение (точное совпадение)</Option>
            <Option value="searchNot">Исключение (вхождение подстроки)</Option>
          </Select>

          {['searchNot', 'search'].includes(searchType) && (
            <AutoComplete
              style={{ width: '80%', marginTop: 12 }}
              dataSource={dataSource}
              value={value.val}
              placeholder="Введите текст"
              onChange={onChangeValue}
            />
          )}
          {['in', 'notIn'].includes(searchType) && (
            <Select mode="tags"  style={{ width: '80%', marginTop: 12 }} placeholder="Выберите значения" value={value.val || []} onChange={onChangeValue}>
              {allValues.map(opt => (
                <Option value={opt} key={opt}>{opt}</Option>
              ))}
            </Select>
          )}
        </InputGroup>
      </div>
    </div>
  );
}


function FilterDate({ value, onChange }) {
  const dateType = (value && value.dateType) || 'start';
  const val = value && value.val;

  const onChangeType = (dateType) => {
    onChange({ ...value, dateType: dateType });
  };

  const onChangeRange = ([from, to]) => onChange({ ...value, val: { from: from, to: to }, dateType });
  const onChangePick = (date) => onChange({ ...value, val: date, dateType });

  return (
    <div className="col-filter-type col filter-date">
      <Select value={dateType} onChange={onChangeType} style={{ width: 120, marginRight: 12 }}>
        <Option value="start">От</Option>
        <Option value="end">До</Option>
        <Option value="startend">Промежуток</Option>
      </Select>

      {dateType === 'start' || dateType === 'end' ? <DatePicker value={val} onChange={onChangePick} /> : ''}
      {dateType === 'startend' ? <RangePicker value={val && val.from && val.to && [val.from, val.to]} onChange={onChangeRange} /> : ''}
    </div>
  );
}

function FilterBool({ value, onChange }) {
  const val = (value && value.val) || null;

  const onChangeState = (newVal) => {
    if(newVal === 'all') {
      newVal = null;
    }
    onChange({ ...value, val: newVal });
  };

  return (
    <div className="col-filter-type col filter-date">
      <h4>Статус</h4>
      <Select value={val === null ? 'all' : val} onChange={onChangeState} style={{ width: 200 }}>
        <Option value="all">Не выбрано</Option>
        <Option value="yes">Да</Option>
        <Option value="no">Нет</Option>
      </Select>
    </div>
  );
}


const fget = (obj, key, _default = '') => get(obj, key) || _default;

export const filterString = (filter, key) => (rows) => {
  let searchVal;
  if (['search', 'searchNot'].includes(filter.searchType)) {
    searchVal = filter.val.toLowerCase().trim();
  } else {
    searchVal = (filter.val || []).map(i => i.toLowerCase().trim());
  }

  const val = (row, key) => {
    let v = fget(row, key);
    if(key === 'lastPass.status' ||  key === 'night_lastPass.status') {
      v = passStatusText(v);
    } else if(key === 'lastPass.duration' || key === 'night_lastPass.duration') {
      v = passDurationText(v);
    }
    return (v || '').toString().trim().toLowerCase();
  };

  const vals = row => {
    const all = [val(row, key)];
    const v2 = val(row, `night_${key}`);
    if (v2) {
      all.push(v2);
    }

    return all;
  };

  const searchIn = (row) => {
    return vals(row).some(i => i.indexOf(searchVal) > -1);
  };
  const searchNot = (row) => !searchIn(row);
  const valIn = (row) => {
    return vals(row).some(v => (searchVal || []).includes(v));
  }
  const valNotIn = (row) => !valIn(row);

  let f;
  if (filter.searchType === 'search') {
    f = searchIn;
  } else if (filter.searchType === 'searchNot') {
    f = searchNot;
  } else if (filter.searchType === 'in') {
    f = valIn;
  } else if (filter.searchType === 'notIn') {
    f = valNotIn;
  }

  return rows.filter(f);
};


export const filterPassStatus = (filter, key) => (rows) => {
  if (filter.val === 'canceled' && filter.date && filter.date.val) {
    rows = filterDate(filter.date, 'lastPass.canceledAt')(rows);
  }

  return rows.filter(row => (fget(row, key) === filter.val) || fget(row, `night_${key}`) === filter.val);
};

export const filterDate = (filter, key, getVal) => (rows) => {
  getVal = getVal || fget;
  const type = filter.dateType;


  const val = (row) => getVal(row, key);
  const val2 = (row) => getVal(row, `night_${key}`);

  const v = filter.val;

  const startFilter = (row) => (val(row) >= v.valueOf() || val2(row) >= v.valueOf());
  const endFilter = (row) => (val(row) <= v.valueOf()) || val2(row) <= v.valueOf();
  const startEndFilter = (row) =>
    (val(row) <= v.to.valueOf() || val2(row) <= v.to.valueOf()) && (val(row) >= v.from.valueOf() || val2(row) >= v.from.valueOf());

  let filterFn;
  if(type === 'startend') {
    filterFn = startEndFilter;
  } else if(type === 'start') {
    filterFn = startFilter;
  } else {
    filterFn = endFilter;
  }

  return rows.filter(filterFn);
};


export const filterBool = (filter, key, getVal) => (rows) => {
  getVal = getVal || fget;
  const searchVal = filter.val === 'yes';
  const val = row => getVal(row, key) === true;
  const val2 = row => getVal(row, `night_${key}`) === true;

  return rows.filter(r => (val(r) === searchVal) || val2(r) === searchVal);
};




// WEBPACK FOOTER //
// ./src/components/pages/clients/filter.js